module.exports = __webpack_public_path__ + "static/media/mmm-star-color.7738308e.svg";